module.exports = __webpack_public_path__ + "static/media/indexEnterprise.284b5990.jpg";